import { useRef, useEffect } from 'react';
import {
  Button,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

export const ConfirmDialog = ({ show, title, text, handler, cancelButtonText, confirmButtonText, closeDialog }) => {
  const buttonRef = useRef(null);

  const handleConfirm = () => {
    handler();
    closeDialog();
  };

  const handleCancel = () => {
    closeDialog();
  };

  useEffect(() => {
    const { current } = buttonRef;
    if (current) current.focus();
  }, [show]);

  useEffect(() => {
    const handleKeydown = (e) => {
      if (e.key === 'Escape') closeDialog();
    };
    window.addEventListener('keydown', handleKeydown);
    return () => window.removeEventListener('keydown', handleKeydown);
  }, [closeDialog]);

  if (!show) return null;

  return (
    <div>
      <MuiDialog
        open={show}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ p: 2 }}
        >
          <Typography
            variant="span"
            sx={{ fontWeight: 400, fontSize: '16px' }}
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack
            justifyContent="center"
            alignItems="center"
            spacing={2}
            sx={{ height: '100%', width: '380px', px: 4, textAlign: 'center' }}
          >
            <WarningAmberIcon sx={{ fontSize: 100, color: 'secondary.dark' }} />
            <Typography
              component="h5"
              variant="body1"
              sx={{ fontWeight: 500, fontSize: '18px' }}
            >
              Are you sure?
            </Typography>
            <Typography
              component="p"
              variant="subtitle2"
              sx={{ fontWeight: 100, px: 2, width: '100%', textWrap: 'pretty', color: '#9ba29e' }}
            >
              {text}
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="ghost"
            color="inherit"
            ref={buttonRef}
            onClick={handleCancel}
            sx={{
              textTransform: 'uppercase',
              letterSpacing: 1.2,
              px: 2.5,
            }}
          >
            {cancelButtonText}
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            autoFocus
            sx={{
              boxShadow: 'none',
              textTransform: 'uppercase',
              letterSpacing: 1.2,
              px: 2.5,
            }}
          >
            {confirmButtonText}
          </Button>
        </DialogActions>
      </MuiDialog>
    </div>
  );
};
